import React from 'react'
import moment from 'moment'
import { FaIcon, faBellPlusSolid } from '@/lib/fa'
import CheckboxWithLabelField from '@/modules/drivers/forms/contract/inputs/CheckboxWithLabelField'
import { DateField } from '@/ui/form/controls/DateField'
import { TimeField } from '@/ui/form/controls/TimeField'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import { useAlertForm } from '../AlertFormContext'

const AlertOptions = () => {
  const { t } = useLocalize()
  const {
    reminderEnabled,
    setReminderEnabled,
    reminderDate,
    setReminderDate,
    reminderTime,
    setReminderTime,
    notRemindAnymore,
    setNotRemindAnymore,
  } = useAlertForm()

  const handleReminderDateChange = (fullDate: string | null) => {
    if (!fullDate) {
      setReminderDate(null)
      return
    }
    const [year, month, day] = fullDate.split('-').map(Number)
    const [hours, minutes] = (reminderTime || '00:00').split(':').map(Number)
    const base = (reminderDate ? reminderDate.clone() : moment())
      .year(year)
      .month(month - 1)
      .date(day)
      .set({ hour: hours, minute: minutes, second: 0, millisecond: 0 })
    setReminderDate(base)
  }

  const handleReminderTimeChange = (time: string | null) => {
    const next = time ?? ''
    setReminderTime(next)
    if (!next || !reminderDate) return
    const [hours, minutes] = next.split(':').map(Number)
    setReminderDate(reminderDate.clone().set({ hour: hours, minute: minutes }))
  }

  return (
    <div className="tw-flex tw-gap-2">
      <div className="tw-jusit tw-flex tw-max-w-[200px] tw-flex-1 tw-items-start tw-gap-2 tw-font-medium tw-text-content-base">
        <FaIcon icon={faBellPlusSolid} className="tw-max-w-[12px]" />
        <p className="tw-text-sm tw-font-semibold tw-text-content-base">
          {t('configuration-menu.reminders')}
        </p>
      </div>

      <div className="tw-flex tw-flex-1 tw-flex-col tw-gap-2">
        <CheckboxWithLabelField
          label={t('addAlertPopup.set-reminder')}
          value={reminderEnabled}
          onChange={setReminderEnabled}
        >
          <div className="tw-flex tw-flex-col tw-gap-3">
            <DateField
              label={t('addAlertPopup.remind-date')}
              value={reminderDate ? reminderDate.format('YYYY-MM-DD') : ''}
              setValue={handleReminderDateChange}
            />
            <TimeField
              label="Godzina"
              value={reminderTime}
              setValue={handleReminderTimeChange}
            />
          </div>
        </CheckboxWithLabelField>

        <CheckboxWithLabelField
          label={t('addAlertPopup.dont-show-reminder')}
          value={notRemindAnymore}
          onChange={setNotRemindAnymore}
        />
      </div>
    </div>
  )
}

export default AlertOptions
